// removed by extract-text-webpack-plugin
module.exports = {"container":"_2IWJAeeOij80RC6oijOP9b","title":"_3PAPyo3y18wQUWVwbRTf7w","icon":"_1b9JeV4jAgVbFLW5GMiEl0"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/Actions/styles.css
// module id = 2848
// module chunks = 0